import { IConfig } from '@shared/directives/ngx-mask';

export const ngxMaskConfig: Partial<IConfig> = {
  thousandSeparator: ',',
  decimalMarker: '.',
  validation: false,
  clearIfNotMatch: false,
};
